// middleware/auth.ts

import { routeRoles } from "~/config/route-roles"

export default defineNuxtRouteMiddleware(async (to, from) => {
    console.log('from', from)
    console.log('to', to)
    
    // if (import.meta.client) {
    //   const auth_store = useAuthStore()

    //   if (!auth_store.tg_init_data_hash) {
    //     console.warn('Storing Telegram init data hash:', window.location.href)
    //     auth_store.store_tg_init_data_hash(window.location.href)
    //   }
    // }

    if (import.meta.client) {
      const auth_store = useAuthStore()

      if (!auth_store.tg_init_data_hash) {
        const tg_web_app = window.Telegram?.WebApp
        const tg_init_data_hash = window.location.hash?.includes('tgWebAppData=')
          ? window.location.hash
          : tg_web_app?.initData || to.fullPath

        auth_store.store_tg_init_data_hash(tg_init_data_hash)
      }
    }

    // const session_storage = useLocalStorage('session', null)

    // if (session_storage.value) {
    //   const session = JSON.parse(session_storage.value || '{}')
    // } else {
    //   console.log('Session is null')

    //   await auth_store.create_session(window.Telegram.WebApp.initData)

    //   return
    // }

    


    
    // console.log('session_token', session_token.value)
    // console.log('auth_store.user', auth_store.user)

    return

    // Если есть токен, но нет пользователя - загружаем информацию о пользователе
    if (session_token.value && !auth_store.user) {
      auth_store.token = session_token.value
      // Загружаем данные пользователя
      await auth_store.get_user()
    }

	if (to.path == '/login') {
		return
	}

	if (to.path == '/access-denied') {
		return
	}

	// Если пользователь не авторизован
	if (!auth_store.user) {
		console.log('User is not authorized')
		return navigateTo({
			path: '/login',
			query: { redirect: to.fullPath },
		});
	}

	// Проверяем, есть ли у пользователя доступ к маршруту
	const hasAccess = routeRoles.some((rule) => {
		// Проверяем, соответствует ли путь регулярке
		if (rule.path.test(to.path)) {
			// Проверяем, есть ли у пользователя хотя бы одна из нужных ролей
			return rule.roles.some((role) => auth_store.user?.roles?.includes(role));
		}
		return false;
	});

	// Если доступа нет, редиректим на страницу "нет доступа"
	if (!hasAccess) {

		console.log(auth_store?.user?.roles)

		if (auth_store?.user?.roles?.includes('admin_deposit_rub')) {
			return navigateTo('/fg')
		}

		if (auth_store?.user?.roles?.includes('admin_fin')) {
			return navigateTo('/fin/expenses')
		}

		if (auth_store?.user?.roles?.includes('trader_deposit_rub')) {
			return navigateTo('/trader_deposit_rub')
		}

    if (auth_store?.user?.roles?.includes('marketer')) {
			return navigateTo('/main_report')
		}

		return navigateTo({
			path: '/access-denied',
			query: { redirect: to.fullPath },
		});
	}
    
    // Список защищенных маршрутов
    const protectedRoutes = [
      '/lists',
      '/dashboard',
      // Добавьте другие защищенные маршруты
    ]

    // Проверяем, является ли текущий маршрут защищенным
    const isProtectedRoute = protectedRoutes.some(route => to.path.startsWith(route))

    console.log('isProtectedRoute', isProtectedRoute)
    
    // Если маршрут защищенный и нет токена - редиректим на логин
    if (isProtectedRoute && !session_token.value) {
      // Показываем модальное окно авторизации
      useAuthStore().auth_modal_show()
      useToast().add({
        title: 'Доступ запрещен',
        description: 'Пожалуйста, авторизуйтесь для доступа к этой странице',
        color: 'red',
        // timeout: 5000,
      })
      // Или редиректим на страницу логина
      // return navigateTo('/login')


      
      // Если хотим сохранить URL для редиректа после логина
      return navigateTo(`/?redirect=${to.fullPath}`)
    }

    if (to.path.startsWith('/cc') && !auth_store.user?.roles?.includes('admin')) {
      return navigateTo('/')
    }
    
    // Если пользователь авторизован и идет на страницу логина - редиректим на главную
    if (session_token.value && to.path === '/login') {
      return navigateTo('/')
    }

    if (to.path == '/' && !auth_store.user?.roles?.includes('admin') && auth_store.user?.roles?.includes('trader_deposit_rub')) {
      return navigateTo('/trader_deposit_rub')
    }

    if (to.path == '/' && !auth_store.user?.roles?.includes('admin') && !auth_store.user?.roles?.includes('fin_reports') && auth_store.user?.roles?.includes('admin_deposit_rub')) {
      return navigateTo('/fg')
    }
  })
